import React, { Component } from 'react';
import './PageNumber.css';

class PageNumber extends Component {
  render() {
    const {
      current,
      all,
    } = this.props;

    return (
      <div className="PageNumber">
        {current} / {all}
      </div>
    );
  }
}

export default PageNumber;



// WEBPACK FOOTER //
// ./src/components/page-number/PageNumber.jsx